__turbopack_context__.v({
  "active": "InterestInsightChart-module-scss-module__Vcl5qG__active",
  "card": "InterestInsightChart-module-scss-module__Vcl5qG__card",
  "chartPlaceholder": "InterestInsightChart-module-scss-module__Vcl5qG__chartPlaceholder",
  "chartPlaceholderText": "InterestInsightChart-module-scss-module__Vcl5qG__chartPlaceholderText",
  "content": "InterestInsightChart-module-scss-module__Vcl5qG__content",
  "header": "InterestInsightChart-module-scss-module__Vcl5qG__header",
  "icon": "InterestInsightChart-module-scss-module__Vcl5qG__icon",
  "insightCard": "InterestInsightChart-module-scss-module__Vcl5qG__insightCard",
  "insightContent": "InterestInsightChart-module-scss-module__Vcl5qG__insightContent",
  "insightHeader": "InterestInsightChart-module-scss-module__Vcl5qG__insightHeader",
  "insightIcon": "InterestInsightChart-module-scss-module__Vcl5qG__insightIcon",
  "insightMainText": "InterestInsightChart-module-scss-module__Vcl5qG__insightMainText",
  "insightSubtext": "InterestInsightChart-module-scss-module__Vcl5qG__insightSubtext",
  "insightSubtextIcon": "InterestInsightChart-module-scss-module__Vcl5qG__insightSubtextIcon",
  "insightText": "InterestInsightChart-module-scss-module__Vcl5qG__insightText",
  "metricCard": "InterestInsightChart-module-scss-module__Vcl5qG__metricCard",
  "metricContent": "InterestInsightChart-module-scss-module__Vcl5qG__metricContent",
  "metricLabel": "InterestInsightChart-module-scss-module__Vcl5qG__metricLabel",
  "metricValue": "InterestInsightChart-module-scss-module__Vcl5qG__metricValue",
  "metricsGrid": "InterestInsightChart-module-scss-module__Vcl5qG__metricsGrid",
  "periodSelector": "InterestInsightChart-module-scss-module__Vcl5qG__periodSelector",
  "quickSelectButton": "InterestInsightChart-module-scss-module__Vcl5qG__quickSelectButton",
  "quickSelectButtons": "InterestInsightChart-module-scss-module__Vcl5qG__quickSelectButtons",
  "sliderContainer": "InterestInsightChart-module-scss-module__Vcl5qG__sliderContainer",
  "sliderLabels": "InterestInsightChart-module-scss-module__Vcl5qG__sliderLabels",
  "subtitle": "InterestInsightChart-module-scss-module__Vcl5qG__subtitle",
  "title": "InterestInsightChart-module-scss-module__Vcl5qG__title",
});
